import { useMutation, gql } from '@apollo/client';
import { IDirectoryFilter } from './useMainDirectoryQuery';

export const UpdateMainDirectoryWorkspace = gql`
    mutation UpdateMainDirectoryWorkspace($params: DirectoryWorkspaceUpdate!) {
        updateMainDirectoryWorkspace(params: $params) {
            dynamicList {
                id
                dateCreated {
                    js
                }
                dateModified {
                    js
                }
                description
                caption
                folder
                parentID
                recordType
                securityUserID
                tableName
            }            
        }
    }
`;

export type SaveTypeEnum = 'SAVE' | 'SAVE_AS';
export type ViewType = 'DYNAMIC_LIST' | 'SAVED_LIST' | 'ALL_ENTRIES' | 'ACTIVE_ENTRIES';

export interface IGridFormat {
    id: string;
    columnVisibility: boolean;
    columnWidth: number;
    columnOrder: number;
}

export interface IUpdateMainDirectoryWorkspaceVars {
    params: {
        id?: number;
        description?: string;
        saveOption: SaveTypeEnum;
        parentID?: number;
        gridFormat: IGridFormat[];
        filters: IDirectoryFilter[];
        viewType: ViewType;
    }
}

export interface IUpdateMainDirectoryWorkspaceData {
    updateMainDirectoryWorkspace: {
        dynamicList: {
            id: string;
            dateCreated: {
                js: string;
            };
            dateModified: {
                js: string;
            };
            description: string;
            caption: string;
            folder: boolean;
            parentID: number;
            recordType: starrez.RecordType;
            securityUserID: number;
            tableName: string;
        }
    };
}

export const useUpdateMainDirectoryWorkspace = () =>
    useMutation<IUpdateMainDirectoryWorkspaceData, IUpdateMainDirectoryWorkspaceVars>(UpdateMainDirectoryWorkspace);
